import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/f1-fantasy")({
  component: F1FantasyLayout,
});

function F1FantasyLayout() {
  return <Outlet />;
}
